<div class="clear-button-wrapper">
    <button
        class="selenium-facets-clear-filters gtm-clear-filters mobile-version"
        (click)="onClearClick()"
    >
        Clear Filters
        <i class="fas fa-trash"></i>
    </button>
</div>

<div class="facet">
    <div *ngIf="!syncFacets" class="label">Filter by</div>
    <app-generic-facet
        facetName="grades"
        layout="grid"
        [isCollapsed]="false"
        [defaultOptions]="grades"
        [staticOptions]="true"
        [syncFacets]="syncFacets"
        class="selenium-facet-grades gtm-facets gtm-facet-grades"
    >
    </app-generic-facet>
    <ng-container *ngIf="premiumCollectionSearch && nestedFacetsInfo.length">
        <app-nested-facet
            *ngFor="let facetInfo of nestedFacetsInfo"
            class="gtm-facets"
            [facetId]="facetInfo.id"
            [isCollapsed]="premiumCollectionSearch"
            [syncFacets]="syncFacets"
            [title]="facetInfo.name"
        >
        </app-nested-facet>
    </ng-container>
    <app-nested-facet
        *ngIf="(chFacetInfo | json) !== '{}'"
        class="selenium-facet-subjects gtm-facets gtm-facet-subjects"
        [facetId]="chFacetInfo.id"
        [isCollapsed]="premiumCollectionSearch"
        [premiumCollectionSearch]="premiumCollectionSearch"
        [syncFacets]="syncFacets"
        [title]="chFacetInfo.name"
    >
    </app-nested-facet>
    <app-generic-facet
        dynamicFacetName="cp"
        [staticOptions]="true"
        [isCollapsed]="true"
        layout="inline"
        *ngIf="premiumCollectionSearch"
        [syncFacets]="syncFacets"
        class="selenium-facet-content-projects gtm-facets gtm-facet-content-projects"
    >
    </app-generic-facet>
    <app-generic-facet
        facetName="media_type"
        layout="inline"
        [isCollapsed]="premiumCollectionSearch"
        [defaultOptions]="mediaTypes"
        [staticOptions]="true"
        [allowedFacetKeys]="mediaTypes"
        [syncFacets]="syncFacets"
        class="selenium-facet-resource-type gtm-facets gtm-facet-resource-type"
    >
    </app-generic-facet>
    <app-generic-facet
        facetName="language"
        layout="inline"
        [syncFacets]="syncFacets"
        [isCollapsed]="premiumCollectionSearch"
        class="selenium-facet-language gtm-facets gtm-facet-language"
    >
    </app-generic-facet>
    <app-accesibility-facet
        [syncFacets]="syncFacets"
        class="selenium-facet-accessibility gtm-facets gtm-facet-accessibility"
    >
    </app-accesibility-facet>
    <app-generic-facet
        facetName="additional_features"
        layout="inline"
        [syncFacets]="syncFacets"
        [isCollapsed]="premiumCollectionSearch"
        class="selenium-facet-additional-features gtm-facets gtm-facet-additional"
    >
    </app-generic-facet>
</div>

<div class="options">
    <button
        class="btn btn-transparent selenium-facets-clear-filters gtm-clear-filters"
        (click)="onClearClick()"
    >
        Clear Filters
        <i class="fas fa-trash"></i>
    </button>
    <a
        class="btn btn-primary selenium-facets-browse-standards gtm-facets-browse-standards"
        href="/standards/0/"
    >
        <i class="fas fa-graduation-cap"></i> Browse Standards
    </a>
</div>
